import React, { FC } from 'react';
import { Button } from '@clearcover/atlas';
import { toTitleCase } from 'Shared/utils';
import { ChallengeType } from 'QuoteApp/services/endpoints/PostChallengeAccident';
interface ChallengeButtonProps {
  onClick(): void;
  variant: ChallengeType;
  disabled?: boolean;
  className?: string;
}

export const ChallengeButton: FC<ChallengeButtonProps> = ({
  onClick,
  variant,
  disabled,
  className,
}) => {
  return (
    <Button
      variant={variant === 'remove' ? 'danger-secondary' : 'secondary'}
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      {toTitleCase(variant)}
    </Button>
  );
};
